<p-dialog
  maskStyleClass="backdrop-blur-sm"
  styleClass="min-w-96!"
  [appendTo]="'body'"
  [closeOnEscape]="canDismiss()"
  [draggable]="true"
  [focusOnShow]="focusOnShow()"
  [header]="header()"
  [modal]="true"
  [resizable]="true"
  [(visible)]="isVisible"
  (onHide)="onVisibilityChange(false)"
  (onShow)="onVisibilityChange(true)"
>
  @if (headerTemplate()) {
    <ng-template #header>
      <ng-container *ngTemplateOutlet="headerTemplate()!" />
    </ng-template>
  }
  <ng-content />
  @if (footerTemplate()) {
    <ng-template #footer>
      <ng-container *ngTemplateOutlet="footerTemplate()!" />
    </ng-template>
  } @else if (modalForm()) {
    <div class="flex align-items-center justify-end mt-3">
      <button
        class="m-1 bg-brand text-white"
        pButton
        severity="secondary"
        type="button"
        [raised]="true"
        [text]="true"
        (click)="closeModal()"
      >
        Cancel
      </button>
      <button
        class="m-1 bg-accent text-brand"
        pButton
        type="button"
        [disabled]="false"
        [raised]="true"
        [text]="true"
        (click)="submitForm($event)"
      >
        Save
      </button>
    </div>
  } @else {
<!--    TODO-->
  }
</p-dialog>
